import React from 'react'
import Portfolio from '../components/sections/portfolio'

const Works = () => {
    return (
        <>
            <Portfolio className={"innerpage-single-area"} />
        </>
    )
}

export default Works